import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from './services/shared.service';
import { environment } from 'environments/environment';
import { AuthService } from './services/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { MessagingService } from './services/messaging.service';
import { firstValueFrom, Subscription, tap } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare let gtag: Function;


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy{
    lastMessage: any;
    private subscription: Subscription = new Subscription();
    /**
     * Constructor
     */
    constructor(
        public _shared: SharedService,
        private router: Router,
        private _auth: AuthService,
        private messagingService: MessagingService
    ) {

        _auth.isAuthenticated().subscribe({
            next: async data => {

               await  this.initilizeNotifications();
                let canc = localStorage.getItem("fcancel");
                if (canc !== null) {
                    this.router.navigate(["/cancel"]);
                }
            }, error: data => {
            }
        });
    }


    async getCognitoUser() {
        return ((await this._auth.getCurrentPoolUser()) || { attributes: null }).attributes;
      }


    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }


    async initilizeNotifications() {
        await this.messagingService.initializeMessaging();
        const user= await this.getCognitoUser();
        let granted = await  this.messagingService.requestPermission();
        if(granted) {
            await this.messagingService.subscribeToTopic(user.sub);
        }

    }
    requestNotificationPermission() {
        if ('Notification' in window) {
          Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
              // console.log('Notification permission granted.');
              this.showNotification('Welcome!', 'Notifications are enabled.');
            } else {
              console.log('Notification permission denied.');
            }
          });
        } else {
          console.log('This browser does not support notifications.');
        }
      }
      showNotification(title: string, body: string) {
        if ('Notification' in window && Notification.permission === 'granted') {
          new Notification(title, { body });
        }
      }

    async ngOnInit(): Promise<void> {

        // Concatenamos el pathname y el search
        const fullPath = window.location.pathname + window.location.search;

        // 1. Registro manual para la carga inicial de la aplicación
        gtag('config', 'G-84J0Q9FVR1', {
            'page_path': fullPath
        });

        // 2. Suscripción para cambios de ruta posteriores (SPA)
        this.subscription.add(
            this.router.events.pipe(
                filter(event => event instanceof NavigationEnd)
            ).subscribe((event: any) => {
                gtag('config', 'G-84J0Q9FVR1', {
                    'page_path': event.urlAfterRedirects
                });
            })
        );

        this._auth.initializeLanguage();


        this.subscription.add(
            this.messagingService.receiveMessage().subscribe(message => {
                //debugger;
              if (message) {
                this.lastMessage = message;
                if ('Notification' in window && Notification.permission === 'granted') {
                    this.showNotification(message.data.Title,  message.data.Body );
                  }
              }
            })
          );
          this.requestNotificationPermission();
    }
}
